import { api } from "../config/api";

const REFERRAL_STORAGE_KEY = "activeReferralCode";
const REFERRAL_STORED_AT_KEY = "activeReferralStoredAt";
const REFERRAL_WINDOW_DAYS = 30;

export const getStoredReferralCode = () => {
  const code = localStorage.getItem(REFERRAL_STORAGE_KEY);
  const storedAt = Number(localStorage.getItem(REFERRAL_STORED_AT_KEY) || 0);
  const expiresAt = storedAt + REFERRAL_WINDOW_DAYS * 24 * 60 * 60 * 1000;

  if (!code || !storedAt || Date.now() > expiresAt) {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
    localStorage.removeItem(REFERRAL_STORED_AT_KEY);
    return "";
  }

  return code;
};

export const storeReferralCode = async (code) => {
  const referralCode = String(code || "").trim();
  if (!referralCode || getStoredReferralCode()) return false;

  try {
    const response = await api.post("/referral/click", { referralCode }, { voidAuth: true });
    if (!response.data.data?.active) return false;
  } catch (error) {
    return false;
  }

  localStorage.setItem(REFERRAL_STORAGE_KEY, referralCode);
  localStorage.setItem(REFERRAL_STORED_AT_KEY, `${Date.now()}`);
  return true;
};

export const clearStoredReferralCode = () => {
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
  localStorage.removeItem(REFERRAL_STORED_AT_KEY);
};
